<script>
    import { _ } from "svelte-i18n";
    import Flex from "svelte-flex";
    import { Row, Cell } from "@smui/data-table";
    import IconButton, { Icon } from "@smui/icon-button";
    import { mdiDelete, mdiArrowULeftTop, mdiCheckBold } from "@mdi/js";

    import { formatVolume, isNumber, isWholeNumber } from "../lib/Functions";
    import DTInputCell from "../common/DTInputCell.svelte";
    import PsPurchasePopupPurchaseRowCell from "./PsPurchasePopupPurchaseRowCell.svelte";
    import PsPurchasePopupPurchaseRowPromoCell from "./PsPurchasePopupPurchaseRowPromoCell.svelte";
    import PsEditPriceCell from "./PsEditPriceCell.svelte";

    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let row = {};
    export let conversionRatio = 1;
    export let roundFactor = 2;
    export let selectedUnits = "kg";
    export let editDisabled = false;

    let rowState;
    let oldConversionRatio = 1;
    let oldParticipation = 0;

    $: if (
        !(
            isNumber(row.participation) &&
            isNumber(row.d1Vol) &&
            isNumber(row.d2Vol) &&
            isNumber(row.d3Vol) &&
            isNumber(row.d4Vol) &&
            isNumber(row.d5Vol) &&
            isNumber(row.d6Vol) &&
            isNumber(row.d7Vol) &&
            isNumber(row.flexVol)
        )
    ) {
        if (row.rowState != "invalid") {
            rowState = row.rowState;
        }
        row.rowState = "invalid";
    }

    $: if (conversionRatio != oldConversionRatio) {
        console.log("===================== conversionRatio changed ====================", conversionRatio, oldConversionRatio);
        if (conversionRatio != 1) {
            row.d1VolConv = Math.round(row.d1Vol * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
            row.d2VolConv = Math.round(row.d2Vol * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
            row.d3VolConv = Math.round(row.d3Vol * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
            row.d4VolConv = Math.round(row.d4Vol * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
            row.d5VolConv = Math.round(row.d5Vol * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
            row.d6VolConv = Math.round(row.d6Vol * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
            row.d7VolConv = Math.round(row.d7Vol * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
            row.flexVolConv = Math.round(row.flexVol * conversionRatio * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
        }
        oldConversionRatio = conversionRatio;
    }

    const computeTotal = () => {
        console.log("===================== computeTotal ====================", row.totalVol);
        let oldTotal = row.totalVol;
        row.totalVol =
            Number(row.d1Vol) + Number(row.d2Vol) + Number(row.d3Vol) + Number(row.d4Vol) + Number(row.d5Vol) + Number(row.d6Vol) + Number(row.d7Vol) + Number(row.flexVol);

        if (!isNumber(row.totalVol)) {
            if (row.rowState != "invalid") {
                rowState = row.rowState;
            }
            row.rowState = "invalid";
        } else if (!["add", "invalid"].includes(row.rowState) && row.totalVol != oldTotal) {
            row.rowState = "updated";
            rowState = "updated";
        } else {
            row.rowState = rowState ? rowState : row.rowState;
        }
    };

    const promoFlagChange = () => {
        rowState = row.rowState;
        if (row.rowState != "invalid") {
            row.rowState = row.rowState != "add" ? "updated" : row.rowState;
        }
    };

    const batchPromoFlagChange = (event) => {
        console.log("===================== batchPromoFlagChange ====================", event);
        let val = !event.detail.checked,
            r = event.detail.row
        for (let day = 1; day <= 7; day++) {
            r["d" + day + "Promo"] = val;
        }
    };

    const volumeChanged = (event) => {
        console.log("===================== volumeChanged ====================", event.detail.type, event.detail.day, event.detail.value);
        if (
            isNumber(row.d1Vol) &&
            isNumber(row.d2Vol) &&
            isNumber(row.d3Vol) &&
            isNumber(row.d4Vol) &&
            isNumber(row.d5Vol) &&
            isNumber(row.d6Vol) &&
            isNumber(row.d7Vol) &&
            isNumber(row.flexVol)
        ) {
            computeTotal();
            dispatch("purchaseTableVolumeChange", { supplierId: row.supplierId, row: row });
        }
    };

    const convertedVolumeChanged = (event) => {
        console.log("===================== convertedVolumeChanged ====================", event.detail.type, event.detail.day, event.detail.valueConv);
        if (event.detail.type == "day") {
            row[`d${event.detail.day}Vol`] = Math.round((event.detail.valueConv / conversionRatio) * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
        } else {
            row.flexVol = Math.round((event.detail.valueConv / conversionRatio) * Math.pow(10, roundFactor)) / Math.pow(10, roundFactor);
        }
        if (
            isNumber(row.d1Vol) &&
            isNumber(row.d2Vol) &&
            isNumber(row.d3Vol) &&
            isNumber(row.d4Vol) &&
            isNumber(row.d5Vol) &&
            isNumber(row.d6Vol) &&
            isNumber(row.d7Vol) &&
            isNumber(row.flexVol)
        ) {
            computeTotal();
            dispatch("purchaseTableConvertedVolumeChange", {
                supplierId: row.supplierId,
                type: event.detail.type,
                day: event.detail.day,
                valueConv: event.detail.valueConv,
                row: row,
            });
        }
    };

 
    const priceChanged = (event ,type, row) => {
        console.log("===================== priceChanged ====================", event.detail, type, row.rowState);
        let promoInd = (type == "promo")? "Promo": "";
        row["price" + promoInd] = Number(event.detail.value); 
        row["price" + promoInd + "Eur"] = Number(event.detail.valueConv);
        if (["origin"].includes(row.rowState)){
            row.rowState = "updated";
        }
    }



</script>

{#if row}
    <Row class="small noborder background-unset">
        <Cell class="datatable-header font-weight-bold">
            <Flex direction="row" justify="between">
                <div class={row.deleted ? "row-deleted" : ""}>
                    {row.supplierName} <span class="cyan-text text-accent-2">({row.countryOfOrigin})</span>
                    {#if row.variety}
                        <br /><span class="font-weight-regular cyan-text text-accent-2"><small>{$_("variety")}: {row.variety}</small></span>
                    {/if}
                </div>
            </Flex>
        </Cell>
        <Cell class="pa-0 tescoblue-border-right-thin noborder" style="min-width: 8rem !important;">
            <Flex direction="row" class="">
                {#if !row.deleted}
                    <div title={$_("delete")}>
                        <IconButton
                            size="button"
                            class="opacity-1"
                            on:click={() => {
                                row.deleted = true;
                                dispatch("purchaseTableVolumeChange", { supplierId: row.supplierId });
                            }}
                        >
                            <Icon tag="svg" viewBox="0 0 24 24" class="tescoblue-text">
                                <path fill="currentColor" d={mdiDelete} />
                            </Icon>
                        </IconButton>
                    </div>
                {:else}
                    <div title={$_("undo")}>
                        <IconButton
                            size="button"
                            class="opacity-1"
                            on:click={() => {
                                row.deleted = false;
                                if (row.status == "rejected") row.status = "prepared";
                                if (row.rowState == "origin") row.rowState = "updated";
                                dispatch("purchaseTableVolumeChange", { supplierId: row.supplierId });
                            }}
                        >
                            <Icon tag="svg" viewBox="0 0 24 24" class="tescoblue-text">
                                <path fill="currentColor" d={mdiArrowULeftTop} />
                            </Icon>
                        </IconButton>
                    </div>
                {/if}

                <DTInputCell
                    id="PurchasePopupSuppPartic_{row.supplierId}"
                    bind:value={row.participation}
                    editable={!row.deleted}
                    class="small pa-0 text-overflow-unset {row.deleted ? 'row-deleted' : ''} {!isNumber(row.participation) ? 'tescored-border' : ''}"
                    withTrailingIcon={true}
                    style="min-width: 6rem !important;"
                    on:keyup={(e) => {
                        console.log("Participation KEY UP", e.key);
                        if (isNumber(row.participation)) {
                            dispatch("participationChanged", {
                                supplierId: row.supplierId,
                                warehouseId: row.warehouseId,
                                participation: row.participation /* ? Number(row.participation) : 0 */,
                            });
                        }
                    }}
                >
                    <svelte:fragment slot="trailingIcon">
                        <Icon class="material-icons {row.deleted ? 'grey-text ' : 'tescoblue-text'}" style="font-size: 12px;">percent</Icon>
                    </svelte:fragment>
                </DTInputCell>
                <!--
                <div title={$_("set_participation")}>
                    <IconButton size="button" class="opacity-1"  on:click={(e) => {
                        dispatch("participationChanged", {
                            supplierId: row.supplierId,
                            warehouseId: row.warehouseId,
                            participation: row.participation ? Number(row.participation) : 0,
                            });
                        }}
                    >
                      <Icon tag="svg" viewBox="0 0 24 24" class="tescoblue-text">
                        <path fill="currentColor" d={mdiCheckBold} />
                      </Icon>
                    </IconButton>
                </div>
-->
            </Flex>
        </Cell>

        <!-- Logistics -->
        <Cell class="pa-0 tescoblue-border-right-thin noborder text-center w-5 {row.deleted ? "row-deleted" : ""}" style="font-size: 0.9em">
                    <span>{row.cartonLogistics}</span>
                    /
                    <span>{row.palletLogistics}</span>
        </Cell>

        <!-- Price -->
        <PsEditPriceCell 
            value={row.price?? null}
            valueConv={row.priceEur?? null}
            writable={!row.deleted}
            deleted={row.deleted}
            rowStyle={""}
            currency={row.currency}
            type="regular"
            bold={false}
            alwaysShowConvValue={false}
            {editDisabled}
            on:startEdit={() => {editDisabled = true;}}
            on:finishEdit={() => {editDisabled = false;}}
            on:valueChanged={(e) => {priceChanged(e, "regular", row);}}
        />  

        <!-- Promo Price -->
        {#if row.pricePromo}
            <PsEditPriceCell 
                value={row.pricePromo?? null}
                valueConv={row.pricePromoEur?? null}
                writable={!row.deleted}
                deleted={row.deleted}
                rowStyle={""}
                currency={row.currency}
                type="promo"
                bold={false}
                alwaysShowConvValue={false}
                {editDisabled}
                on:startEdit={() => {editDisabled = true;}}
                on:finishEdit={() => {editDisabled = false;}}
                on:valueChanged={(e) => {priceChanged(e, "promo", row);}}
            />  
        {:else}
            <Cell class="pa-0 tescoblue-border-right-thin noborder">
            </Cell>
        {/if}

        <!-- Week Promo -->
        <Cell class="pa-0 tescoblue-border-right-thin noborder">
            <PsPurchasePopupPurchaseRowPromoCell
                bind:row={row}
                disabled={row.deleted || !row.pricePromo}
                on:promoFlagChange={batchPromoFlagChange}
            />
        </Cell>

        <!-- For each day MON to SUN -->
        {#each [1, 2, 3, 4, 5, 6, 7] as day (day)}
            {@const value = (conversionRatio == 1)? row[`d${day}Vol`]: row[`d${day}VolConv`]}
            <Cell class="pa-0 tescoblue-border-right-thin noborder {(['pallets'].includes(selectedUnits) && !isNumber(value) || (['kg','cases'].includes(selectedUnits) && !isWholeNumber(value))) ? 'tescored-border' : ''}">
                <PsPurchasePopupPurchaseRowCell
                    bind:value={row[`d${day}Vol`]}
                    bind:valueConv={row[`d${day}VolConv`]}
                    bind:promoFlag={row[`d${day}Promo`]}
                    type="day"
                    {day}
                    disabled={row.deleted}
                    {conversionRatio}
                    price={row.price}
                    units={row.units}
                    currency={row.currency}
                    priceEur={row.priceEur}
                    pricePromo={row.pricePromo}
                    pricePromoEur={row.pricePromoEur}
                    on:change={volumeChanged}
                    on:changeConverted={convertedVolumeChanged}
                    on:promoFlagChange={() => {
                        dispatch("promoFlagChange");
                        promoFlagChange();
                    }}
                />
            </Cell>
        {/each}

        <!-- FlexVolume -->
        <Cell class="pa-0 tescoblue-border-right-thin noborder {!isNumber(row.flexVol) ? 'tescored-border' : ''}">
            <PsPurchasePopupPurchaseRowCell
                bind:value={row.flexVol}
                bind:valueConv={row.flexVolConv}
                type="flex"
                disabled={row.deleted}
                {conversionRatio}
                price={row.price}
                units={row.units}
                currency={row.currency}
                priceEur={row.priceEur}
                pricePromo={row.pricePromo}
                pricePromoEur={row.pricePromoEur}
                on:change={volumeChanged}
                on:changeConverted={convertedVolumeChanged}
            />
        </Cell>

        <!--
        <Cell class="pa-0 tescoblue-border-right-thin noborder {!isNumber(row.flexVol)? "tescored-border": ""}">
            <Row class="small noborder background-unset">
                <Cell class="pa-0 noborder" style="border-bottom: 0px">
                    <DTInputCell
                        bind:value={row.flexVol}
                        disabled={row.deleted}
                        editable={!row.deleted}
                        class="small {row.deleted ? 'row-deleted' : ''}"
                        on:change={() => {
                            if (isNumber(row.d1Vol) && isNumber(row.d2Vol) && isNumber(row.d3Vol) && isNumber(row.d4Vol) && isNumber(row.d5Vol) && isNumber(row.d6Vol) && isNumber(row.d7Vol) && isNumber(row.flexVol) ) {
                                computeTotal();
                                dispatch("purchaseTableVolumeChange");
                            }
                        }}
                    />
                </Cell>
            </Row>
            {#if conversionRatio != 1}
                <Row style="height: 1rem; background-color: inherit">
                    <Cell numeric colspan="2" class="noborder {row.deleted ? 'row-deleted' : ''}">{formatVolume(row.flexVol * conversionRatio)}</Cell>
                </Row>
            {/if}
        </Cell>
-->
        <Cell numeric class="pa-0 noborder">
            <div class="mdc-data-table__row small">
                <Cell numeric class="text-bold  {row.deleted ? 'row-deleted grey-text' : ''}" style="border-bottom: 0px; float: right; padding-top: .3rem;">
                    {conversionRatio == 1 ? formatVolume(row.totalVol) : formatVolume(row.totalVol * conversionRatio)}
                </Cell>
            </div>
            {#if conversionRatio != 1}
                <div class="mdc-data-table__row small" style="height: 1rem; background-color: inherit; float: right;">
                    <Cell numeric colspan="2" class={row.deleted ? "row-deleted" : ""}>{formatVolume(row.totalVol)}&nbsp;{$_(row.units)}</Cell>
                </div>
            {/if}
        </Cell>
    </Row>
{/if}
